import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {saveSelectedCustomer} from "../../../redux/Actions/customers.actions";

export const useCustomerTableActions = () => {
  const {
    isOpen: editModalStatus,
    onOpen: openEditModal,
    onClose: closeEditModal,
  } = useDisclosure();
  const {
    isOpen: isCustomFieldModalOpen,
    onOpen: openCustomFieldModal,
    onClose: closeCustomFieldModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => {
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      setSelectedRow(data);
      switch (action) {
        case "Edit":
          openEditModal();
          break;
        case "View_Custom_Fields":
          openCustomFieldModal();
          break;
        case "Contacts":
          dispatch(saveSelectedCustomer(data));
          navigate("/app/contacts");
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleCustomFieldModalClose = () => {
    closeCustomFieldModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  return {
    closeCustomFieldModal: handleCustomFieldModalClose,
    closeEditModal: handleEditModalClose,
    editModalStatus,
    isCustomFieldModalOpen,
    handleActionSelection,
    selectedRow,
  };
};
